import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CalloutComponent } from './components/callout/callout.component';
import { SharedModule } from '../../shared/shared.module';
import { ModalsModule } from '../modals/modals.module';
import { ModalWrapperComponent } from '../modals/components/modal-wrapper/modal-wrapper.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    ModalsModule
  ],
  declarations: [CalloutComponent],
  exports: [
    CalloutComponent,
    ModalWrapperComponent,
  ]

})
export class CalloutsModule { }
